import { useTranslation } from "react-i18next";
import styled from "styled-components";
import media from "../../styles/media";
import Container from "../ui/Container";
import { ButtonLink } from "../ui/Button";
import { ROUTES } from "../../config/routes";
import heroImage from "../../assets/img/hero-aral.png";

const Wrapper = styled.section`
  padding: 40px 0;
  background-color: ${({ theme }) => theme.colors.surfaceAlt};
`;

const Banner = styled.div`
  position: relative;
  display: flex;
  min-height: 520px;
  align-items: center;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radii.md};
  background-image: url(${heroImage});
  background-size: cover;
  background-position: center;

  ${media.md} {
    min-height: 380px;
  }
`;

const Overlay = styled.div`
  display: flex;
  width: min(760px, 100%);
  min-height: inherit;
  flex-direction: column;
  justify-content: center;
  gap: 28px;
  align-self: stretch;
  padding: 48px;
  background-color: rgba(0, 166, 214, 0.72);
  color: ${({ theme }) => theme.colors.onPrimary};

  ${media.md} {
    padding: 28px 20px;
    gap: 18px;
  }
`;

const Title = styled.h1`
  max-width: 32ch;
  font-size: ${({ theme }) => theme.fontSizes.display};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.onPrimary};

  ${media.md} {
    font-size: ${({ theme }) => theme.fontSizes.h3};
  }
`;

const Description = styled.p`
  max-width: 60ch;
  font-size: ${({ theme }) => theme.fontSizes.md};

  ${media.md} {
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

/**
 * Раньше это был Swiper с одним-единственным слайдом и включённым autoplay —
 * ~120 КБ библиотеки ради статичной картинки.
 */
export function HeroSection() {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <Banner>
          <Overlay>
            <Title>{t("newsTitle")}</Title>
            <Description>{t("newsDescription")}</Description>
            <div>
              <ButtonLink to={ROUTES.news} $variant="ghost">
                {t("readMore")}
              </ButtonLink>
            </div>
          </Overlay>
        </Banner>
      </Container>
    </Wrapper>
  );
}

export default HeroSection;
